import di from 'di'

import { GlobalPlugin, StoragePlugin, StylePlugin } from '@wittignl/js-core'

export default function(app){

    // Core
    app.use(new StoragePlugin());
    app.use(new StylePlugin());
    app.use(GlobalPlugin, {
        $di: di
    })
}